import { STORE_TERMS, TERMS_ACCEPTED } from "./constants"

export const storeTerms = (terms) => ({
  tcTerms: terms
    .map((el) => Object.entries(el)[0])
    .reduce(
      (acc, [id, { blocks }]) => ({
        ...acc,
        [id]: { blocks },
      }),
      {}
    ),
  type: STORE_TERMS,
})

export const acceptTerms = (module) => ({
  module,
  type: TERMS_ACCEPTED,
})
